import { registerPlugin } from '@capacitor/core';

export interface NavigationModeResult {
  mode: 'gesture' | 'buttons';
  isGesture: boolean;
  navBarVisible: boolean;
  gestureLeft: number;
  gestureRight: number;
}

export interface NavigationModePlugin {
  getMode(): Promise<NavigationModeResult>;
}

export const NavigationMode = registerPlugin<NavigationModePlugin>('NavigationMode');
